// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.acc-name {\n  color: #222b2d;\n  margin: 0 10px 0 0;\n}\n.user-avatar {\n  width: 30px;\n  border-radius: 50%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
